import { request } from '../../Common/api/client';

/**
 * POST /api/cp/login - 가맹점 로그인
 * Body: { cpId, password }
 * 응답: cp(id, cp_id, name, status), must_change_password
 */
export async function cpLogin({ cpId, password }) {
  return request({
    method: 'POST',
    url: '/api/cp/login',
    data: { cpId, password },
  });
}

/**
 * POST /api/cp/logout - 가맹점(CP) 세션 종료, 세션 쿠키 삭제
 */
export async function cpLogout() {
  return request({ method: 'POST', url: '/api/cp/logout' });
}

/**
 * POST /api/cp/change-password - 가맹점 비밀번호 변경
 * Body: { currentPassword, newPassword }
 */
export async function cpChangePassword({ currentPassword, newPassword }) {
  return request({
    method: 'POST',
    url: '/api/cp/change-password',
    data: { currentPassword, newPassword },
  });
}

/**
 * POST /api/cp/terminal/ - 영업자 신규 등록
 * Body: { name, phone, tempPassword, terminalId?, memo? }
 * 응답: terminal_id, terminalId, tempPassword
 */
export async function createCpTerminal({ name, phone, tempPassword, terminalId, memo }) {
  const data = { name, phone, tempPassword };
  const tid = terminalId != null ? String(terminalId).trim() : '';
  if (tid) data.terminalId = tid;
  const m = memo != null ? String(memo).trim() : '';
  if (m) data.memo = m;
  return request({
    method: 'POST',
    url: '/api/cp/terminal/',
    data,
  });
}

/**
 * GET /api/cp/terminal/ - 영업자 목록
 * Query: q, status, page, limit
 */
export async function getCpTerminalList(params = {}) {
  return request({ method: 'GET', url: '/api/cp/terminal/', params });
}

/**
 * POST /api/cp/terminal/update - 영업자 정보 수정
 * Body: { id, name?, phone?, status?, memo? }
 */
export async function updateCpTerminal(payload) {
  return request({
    method: 'POST',
    url: '/api/cp/terminal/update',
    data: payload,
  });
}

/**
 * GET /api/cp/payment/manual - 수기결제(영업자별) 목록
 */
export async function getCpManualPayments(params = {}) {
  return request({ method: 'GET', url: '/api/cp/payment/manual', params });
}

/**
 * POST /api/cp/payment/manual/pharmacy-name - 거래 약국명 변경
 * Body: { id: payment_transaction_id, pharmacyName, reason? }
 */
export async function updateCpManualPaymentPharmacyName({ id, pharmacyName, reason = '' }) {
  const data = { id, pharmacyName };
  const trimmedReason = String(reason || '').trim();
  if (trimmedReason) data.reason = trimmedReason;
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual/pharmacy-name',
    data,
  });
}

/**
 * GET /api/cp/payment/manual/terminal-summary - 영업자 기간별 매출 요약
 * Query: dateFrom, dateTo
 */
export async function getCpManualPaymentTerminalSummary(params = {}) {
  return request({ method: 'GET', url: '/api/cp/payment/manual/terminal-summary', params });
}

/**
 * POST /api/cp/terminal/change-password-by-cp - 영업자 비밀번호 변경
 * Auth: CP 세션 필요
 * Body: { id, newPassword }
 */
export async function terminalChangePassword({ id, newPassword }) {
  return request({
    method: 'POST',
    url: '/api/cp/terminal/change-password-by-cp',
    data: { id, newPassword },
  });
}

/**
 * GET /api/cp/customer - 고객(약국) 목록
 * Query: q, status, page, limit, terminalId(선택)
 * 전체 또는 특정 영업자로 필터링된 고객 목록 조회
 */
export async function getCpCustomerList(params = {}) {
  return request({ method: 'GET', url: '/api/cp/customer', params });
}

/**
 * POST /api/cp/customer/assign-terminal - 약국 담당 영업자 변경
 * Body: { customerId, terminalId }
 * terminalId가 null이면 담당 영업자 할당 해제
 */
export async function updateCpCustomerTerminal({ customerId, terminalId }) {
  return request({
    method: 'POST',
    url: '/api/cp/customer/assign-terminal',
    data: { customerId, terminalId },
  });
}

/**
 * POST /api/cp/payment/manual/reveal-card - 전표 카드번호 조회
 * Body: { paymentTransactionId, password, reason }
 * 응답: { card_no_masked }
 */
export async function revealCpManualPaymentCard({ paymentTransactionId, password, reason }) {
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual/reveal-card',
    data: { paymentTransactionId, password, reason },
  });
}

/**
 * POST /api/cp/payment/manual/receipt-email - 전표 이메일 전송
 * Body: { paymentTransactionId, payment_transaction_id, email }
 */
export async function sendCpManualPaymentReceiptEmail({ paymentTransactionId, payment_transaction_id, email }) {
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual/receipt-email',
    data: { paymentTransactionId, payment_transaction_id, email },
  });
}

export async function sendCpManualPaymentReceiptSms({ paymentTransactionId, phone }) {
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual/receipt-sms',
    data: { paymentTransactionId, phone },
  });
}

export async function sendCpManualPaymentReceiptAlimtalk({ paymentTransactionId, phone }) {
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual/receipt-alimtalk',
    data: { paymentTransactionId, phone },
  });
}
